module.exports = new __parcel__URL__("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg").toString();